import { TControlButtonSize } from './types';

import * as styles from './styles.css';

export const SIZE_TO_CLASS: { [key in TControlButtonSize]: string } = {
  M: styles['middle'],
  L: styles['large'],
  XL: styles['extra-large'],
};
